<template>
  <div class="min-h-screen bg-gray-100">
    <nav class="bg-indigo-700 text-white">
      <div class="max-w-7xl mx-auto px-4 py-3 flex items-center gap-6">
        <span class="font-bold text-lg">Admin Panel</span>
        <router-link to="/admin/dashboard" class="hover:text-indigo-200">Dashboard</router-link>
        <router-link to="/admin/ipos" class="hover:text-indigo-200">IPOs</router-link>
        <router-link to="/admin/gmp" class="hover:text-indigo-200">GMP</router-link>
        <router-link to="/admin/articles" class="hover:text-indigo-200">Articles</router-link>
        <router-link to="/admin/ai-suggestions" class="hover:text-indigo-200">AI Suggestions</router-link>
        <div class="ml-auto flex items-center gap-4">
          <span class="text-sm">{{ auth.user?.name }}</span>
          <router-link to="/" class="text-sm hover:text-indigo-200">View Site</router-link>
          <button @click="logout" class="text-sm hover:text-red-300">Logout</button>
        </div>
      </div>
    </nav>
    <main class="max-w-7xl mx-auto px-4 py-6">
      <slot />
    </main>
  </div>
</template>

<script setup>
import { auth } from '../auth';
import axios from 'axios';
import { useRouter } from 'vue-router';

const router = useRouter();
async function logout() {
  try { await axios.post('/api/auth/logout'); } catch {}
  auth.clearAuth();
  router.push('/login');
}
</script>
